
import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment/productportfolyo`;

export const productPortfolioService = {

    getOrderList: async function (SupplierCode: string, LocationCode: string, CategoryCode: string, ProductCode: string) {
        return axios.get(`${GATEWAY_URL}/get_portfolyos`, {
            params: {
                SupplierCode: SupplierCode,
                LocationCode: LocationCode,
                CategoryCode: CategoryCode,
                ProductCode: ProductCode
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getOrderDetailList: async function (siteCode: string, productCode: string) {
        return axios.get(`${GATEWAY_URL}/inventory_transaction_list`, {
            params: {
                SiteCode: siteCode,
                ProductCode: productCode
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getLocationsLookup: async function () {
        return axios.get(`${GATEWAY_URL}/get_locations_lookup`)
            .then((response) => {
                return response.data;
            });
    },

     getCategoriesLookup: async function () {
        return axios.get(`${GATEWAY_URL}/get_category_lookup`)
            .then((response) => {
                return response.data;
            });
    },

     getProductsLookup: async function () {
        return axios.get(`${GATEWAY_URL}/get_products_lookup`)
            .then((response) => {
                return response.data;
            });
    },

    getSuppliersLookup: async function (locationCode: string) {
        return axios.get(`${GATEWAY_URL}/getlocation_suppliers_lookup`, {
            params: {
                LocationCode: locationCode
            }
        })
            .then((response) => {
                return response.data;
            });
    },


    paymentTypeLookup: async function () {
        return axios.get(`${GATEWAY_URL}/inventory_types_lookup`, {
            params: {
                LocationTypeCode: "S"
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    savePayment: async function (values: any) {
        return axios.post(`${GATEWAY_URL}/site_inventory_transaction_save`, values)
            .then((response) => {
                return response.data;
            });
    },

    deletePayment: async function (values: any) {
        return axios.post(`${GATEWAY_URL}/inventory_transaction_delete`, { id: values })
            .then((response) => {
                return response.data;
            });
    },

    getlocation_suppliers: async function () {
        return axios.get(`${GATEWAY_URL}/getlocation_suppliers`, {
            params: {
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    updateProductPortfolio: async function (values: any) {
        return axios.put(`${GATEWAY_URL}/update_product_portfolyo`, values)
            .then((response) => {
                return response.data;
            });
    },

    getTransactions: async function (ProductCode: any, SupplierCode: any, LocationCode: any) {
        return axios.get(`${GATEWAY_URL}/get_portfolyo_histories`, {
            params: {
                ProductCode: ProductCode,
                SupplierCode: SupplierCode,
                LocationCode: LocationCode
            }
        })
            .then((response) => {
                return response.data;
            });
    },

}
